import * as _ from "lodash";
import { Action } from "redux";
import * as LogLevelActions from "../actions/LogLevelActions";
import { LogLevelDialogState } from "../model/LogLevelSetting";

export function logLevelDialogState(state: LogLevelDialogState = { showDialog: false }, action: Action): LogLevelDialogState {
    switch (action.type) {
        case LogLevelActions.SHOW_LOG_LEVEL_SETTINGS:
            const showLogSettingAction = action as LogLevelActions.IShowLogLevelSettingsAction;
            return {
                showDialog: true,
                allowLogEverything: showLogSettingAction.allowLogEverything,
                isAgentGroupSetting: showLogSettingAction.processIds == null,
                environmentName: showLogSettingAction.environmentName,
                processIds: showLogSettingAction.processIds,
                currentSettings: showLogSettingAction.processIds == null ? showLogSettingAction.settings.agentGroupSettings : showLogSettingAction.settings.processSettings,
                loadedSettings: showLogSettingAction.settings,
                selectedProcessesSupportLogLevelErrorsWithDisabledPromotedResultLogging: showLogSettingAction.selectedProcessesSupportLogLevelErrorsWithDisabledPromotedResultLogging,
            };
        case LogLevelActions.CLOSE_LOG_LEVEL_SETTINGS:
            return { showDialog: false };
        case LogLevelActions.SET_LOG_LEVEL:
            {
                const logLevelAction = action as LogLevelActions.ISetLogLevelAction;
                const newState = _.cloneDeep(state) as LogLevelDialogState;
                if (newState.currentSettings !== undefined) {
                    newState.currentSettings.logLevel = logLevelAction.logLevel;
                }
                return newState;
            }
        case LogLevelActions.DEBUG_EXPIRES_IN:
            {
                const debugExpiresAtAction = action as LogLevelActions.IDebugExpiresAtAction;
                const newState = _.cloneDeep(state) as LogLevelDialogState;
                if (debugExpiresAtAction.expiresIn === 0 && newState.currentSettings !== undefined) {
                    newState.currentSettings.debugExpiresAt = null;
                }
                if (newState.currentSettings !== undefined && debugExpiresAtAction.expiresIn !== null) {
                    newState.currentSettings.setDebugeExpiresInSeconds = debugExpiresAtAction.expiresIn;
                }
                return newState;
            }
        case LogLevelActions.SET_LOG_REQUEST_RESPONSE:
            {
                const setRequestResponseAction = action as LogLevelActions.ISetLogReqestResponseAction;
                const newState = _.cloneDeep(state) as LogLevelDialogState;
                if (newState.currentSettings !== undefined) {
                    newState.currentSettings.logTriggerRequestAndResponse = setRequestResponseAction.logRequestResponse;
                }
                return newState;
            }
        case LogLevelActions.SET_RETENTION_DAYS:
            {
                const setRetentionDaysAction = action as LogLevelActions.ISetRetentionDaysAction;
                const newState = _.cloneDeep(state) as LogLevelDialogState;
                if (newState.currentSettings !== undefined) {
                    newState.currentSettings.historyStorageDays = setRetentionDaysAction.days;
                }
                return newState;
            }
        default:
            return state;
    }
}
